// export.service.ts
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { environment } from "src/environments/environment";

export type IData = {
  format: number;
  fileNames?: Array<string>;
  fileNameList?: Array<string>;
};

@Injectable({
  providedIn: "root"
})
export class ExportCertificateReportService {
  baseUrl: string;

  private isLoadingSubject = new BehaviorSubject<boolean>(false);
  private exportDataSubject = new BehaviorSubject<IData>({} as IData);
  private exportStatusSubject = new BehaviorSubject<boolean>(false);
  private reloadExportDataSubject = new BehaviorSubject<IData>({} as IData);
  private checkExportStatusDataSubject = new BehaviorSubject<any>({} as any);

  isLoading$ = this.isLoadingSubject.asObservable();
  exportData$ = this.exportDataSubject.asObservable();
  exportStatus$ = this.exportStatusSubject.asObservable();
  reloadExportData$ = this.reloadExportDataSubject.asObservable();
  checkExportStatusData$ = this.checkExportStatusDataSubject.asObservable();

  constructor(
    private http: HttpClient
  ) {
    this.baseUrl = environment.API_URL;
  }

  setLoading(isLoading: boolean) {
    this.isLoadingSubject.next(isLoading);
  }

  setExportData(data: any) {
    this.exportDataSubject.next(data);
  }

  setExportStatus(status: boolean) {
    this.exportStatusSubject.next(status);
  }

  reloadExportData(data: IData) {
    this.reloadExportDataSubject.next(data);
  }

  checkExportStatus(data: any) {
    this.checkExportStatusDataSubject.next(data);
  }

  reset() {
    this.isLoadingSubject.next(false);
    this.exportDataSubject.next({} as IData);
    this.exportStatusSubject.next(false);
    this.reloadExportDataSubject.complete();

    this.reloadExportDataSubject = new BehaviorSubject<IData>({} as IData);
    this.reloadExportData$ = this.reloadExportDataSubject.asObservable();
  }

  // new export certificates
  exportValidInvalidCertificates(obj: any) {
    return this.http.post(this.baseUrl + 'api/reports/export-valid-invalid-certificates-report-to-excel', obj);
  }

  addExportRequest(obj: any) {
    return this.http.post(this.baseUrl + 'api/reports/add-valid-certificates-report-export-request', obj);
  }

  getCurrentExportRequest() {
    return this.http.get(this.baseUrl + `api/reports/get-current-export-request-detail-of-login-user`);
  }

  getExportRequestStatus(Id: any) {
    return this.http.get(this.baseUrl + `api/reports/get-export-request-status/${Id}`);
  }

  getExportRequestDetails(Id: any) {
    return this.http.get(this.baseUrl + `api/reports/get-export-request-details/${Id}`);
  }

  deleteCurrentDownload(id: string) {
    return this.http.delete(this.baseUrl + `api/reports/delete-export-reuqest/${id}/`);
  }
}
